import FilterAndValue from "components/filters/FilterAndValue";
import ArtistFilter from "components/filters/Filters/ArtistFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import ProductionFilter from "components/filters/Filters/ProductionFilter";
import StatusFilter from "components/filters/Filters/StatusFilter";
import TagFilter from "components/filters/Filters/TagFilter";
import FilterValue from "components/filters/FilterValue";
import React, { useContext } from "react";
import { DisplayMode } from "./PlanningMapApp";
import { getListUniqueKey } from "./planningMapHelpers";
import PlanningMapList from "./PlanningMapList";
import { ShowForMap } from "./ShowForMap";
import { FilterContext } from "components/filters/FilterContext";
import PlanningMapVirtualizedListItem from "./PlanningMapVirtualizedListItem";
import { GoogleMapShowPinForMapList } from "components/GoogleMap/pins/PinForList";

interface Props {
  showStatuses: server.dto.StatusSmall[]
  showTags: server.dto.TagSmall[]
  shows: server.dto.ShowForPlanningMap[]
  selectedShows: server.dto.ShowForPlanningMap[]
  total: number
  hoveredShows: server.dto.ShowForPlanningMap[]
  isLayerSelected: boolean
  onLayerToggle: () => void
  onViewAllClick: () => void
  displayMode: DisplayMode
  onDisplayModeChange: (displayMode: DisplayMode) => void;
  onSidePanelOpen: (item: server.dto.ShowForPlanningMap) => void
  isInitialLoading: boolean
  error?: string
  onHover: (show: server.dto.ShowForPlanningMap) => void
  isFetching: boolean;
}

const ShowRenderer = (props: { data: Props, index: number, style: React.CSSProperties }) => {
  const show = props.data.shows[props.index];
  return <PlanningMapVirtualizedListItem {...props}>
    <ShowForMap
      onOpen={() => props.data.onSidePanelOpen(show)}
      hovered={props.data.hoveredShows.findIndex(v => v.showId === show.showId) !== -1}
      selected={props.data.selectedShows.includes(show)}
      show={show}
      onHover={props.data.onHover}
    />
  </PlanningMapVirtualizedListItem>
}

const PlanningMapShowList = (props: Props) => {
  const { isDefault } = useContext(FilterContext);

  return <PlanningMapList
    startUncollapsed
    displayMode={props.displayMode}
    onDisplayModeChange={props.onDisplayModeChange}
    uniqueId={getListUniqueKey("show")}
    rowHeight={106} // This should be the height of ShowForMap + 4px for the item spacing
    isLayerSelected={props.isLayerSelected}
    onLayerToggle={props.onLayerToggle}
    onViewAllClick={props.onViewAllClick}
    title={site.currentEnvironment.show.plural}
    total={props.total}
    pin={<GoogleMapShowPinForMapList />}
    hasFilters={!isDefault}
    isInitialLoading={props.isInitialLoading}
    error={props.error}
    numberOfRows={props.shows.length}
    itemData={props}
    renderer={ShowRenderer}
    selectedItems={props.selectedShows}
    isFetching={props.isFetching}
  >
    {props.showStatuses.length > 1 && <FilterAndValue>
      <StatusFilter initialStatuses={props.showStatuses} />
      <FilterValue filterKey="statuses" />
    </FilterAndValue>}

    <FilterAndValue>
      <PeriodFilter />
      <FilterValue filterKey="period" />
    </FilterAndValue>

    <FilterAndValue>
      <ArtistFilter />
      <FilterValue filterKey="artist" />
    </FilterAndValue>

    {props.showTags.length > 0 && <FilterAndValue>
      <TagFilter initialTags={props.showTags} mainArea="show" />
      <FilterValue filterKey="tags" />
    </FilterAndValue>}

    {site.currentEnvironment.tour.enabled && <FilterAndValue>
      <ProductionFilter />
      <FilterValue filterKey="production" />
    </FilterAndValue>}

  </PlanningMapList>
}

export default PlanningMapShowList;